import { createContext, useState, useContext } from "react"

export const GameInforContext = createContext()

const GameInforProvider = ({ children }) => {
    const [user, setUser] = useState({
        id   : "",
        name : ""
    })
    const [room, setRoom] = useState({
        id    : "",
        name  : "",
        users : []
    })
    const [gameInfor, setGameInfor] = useState({
        status            : "",
        userid_set_shadow : user.id,
        shadow            : {
            indexes        : [],
            is_biggest_num : true,
            extends        : {
                math_sign : "+",
                num       : 0
            }
        },
        series : [],
        equals : []
    })

    return (
        <GameInforContext.Provider
            value={ {
                user,
                setUser,
                room,
                setRoom,
                gameInfor, setGameInfor
            } }
        >
            { children }
        </GameInforContext.Provider>
    )
}

export const useGameInforContext = () => {
    const context = useContext(GameInforContext)

    if (context === undefined){
        throw new Error(`useContext must be used within a Provider`)
    }

    return context
}

export default GameInforProvider
